import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=2355f0cf&scoped=true&"
import script from "./SvgIcon.vue?vue&type=script&lang=js&"
export * from "./SvgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2355f0cf",
  null
  
)

export default component.exports